import { debug, george, helpers, i18n, pr, theme, ui } from "aaa";
import { ChooseAddressResponsive } from "components/common/ChooseAddress";
import { ChooseEmailResponsive } from "components/common/ChooseEmail";
import * as FileSaver from "file-saver";
import { observer } from "mobx-react";
import { GenericAPIClient } from "network/APIClient";
import * as React from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { b64ToBlob, b64ToUint8 } from "util/helpers";
import { CreditCardUpgradeRoutes } from "./CreditCardUpgradeRoutes";
import { CreditCardUpgradeStore } from "./CreditCardUpgradeStore";
import { GenericDocument } from "types/documents";
import trackingStore from "stores/TrackingStore";

export const CreditCardUpgradePersonalData = observer(({ store }: { store: CreditCardUpgradeStore }) => {
    const [approvalChecked, setApprovalChecked] = React.useState(false);

    const PageComponent = externalInterfaceStore.isGeorgeApp ? george.PageWithActionButton : React.Fragment;

    const buttonDisabled = !approvalChecked || !store.contactsStore.selectedAddressId || !store.contactsStore.selectedEmailAddressId;

    const handleDownload = async (url: string, title: string) => {
        try {
            const response = await GenericAPIClient.requestType<GenericDocument>({
                // For local testing we replace the https:// prefix with our proxy url
                url: url.replace("https://", ""),
                method: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                parse: json => json as GenericDocument
            });

            if (atob(response.content).slice(0, 1025).includes("%PDF-")) {
                if (helpers.isAndroid() || helpers.isIos()) {
                    store.pdfData = b64ToUint8(response.content);
                    pushRoute(CreditCardUpgradeRoutes.PDF);
                } else {
                    const blob = b64ToBlob(response.content, "application/pdf");
                    FileSaver.saveAs(blob, title);
                }
            }
        } catch (error) {
            pushRoute("/error");
        }
    };

    return (
        <george.BackgroundWithNavBar>
            <PageComponent>
                <george.Card style={{ marginBottom: theme.MARGIN_SMALL }}>
                    <div style={{ padding: theme.MARGIN }}>
                        <ChooseAddressResponsive
                            contactsStore={store.contactsStore}
                            noAddressMessage={ui.__("shop.personalData.noAddress.message")}
                            onNewAddress={() => pushRoute(CreditCardUpgradeRoutes.NEW_ADDRESS)}
                            description={ui.__("creditCardUpgrade.personalData.address.message", { productName: store.upgradeDetails?.offer?.product })}
                        />
                    </div>
                    <pr.LightSeparatorLine />
                    <div style={{ padding: theme.MARGIN }}>
                        <ChooseEmailResponsive
                            contactsStore={store.contactsStore}
                            description={ui.__("a11y.chooseEmail")}
                        />
                    </div>
                    <pr.A11yPopupHider>
                        <pr.LightSeparatorLine />
                        <div style={{ padding: theme.MARGIN }}>
                            <george.ApprovalEmbedded
                                title={ui.__("common.approval")}
                                onCheck={(event, checked) => setApprovalChecked(checked)}
                                message={<i18n.FormattedHTMLMessage id="creditCardUpgrade.personalData.approval" />}
                            />
                        </div>
                        {Object.keys(store.upgradeDetails?._links ?? {}).map((documentKey) => {
                            const document = store.upgradeDetails?._links[documentKey];
                            const documentUrl = document.href;

                            return documentUrl && (
                                <div
                                    key={documentKey}
                                    role="button"
                                    onClick={() => handleDownload(documentUrl, document.title)}
                                    className="theme-secondary-action-label-color"
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        fontWeight: 600,
                                        fontSize: 14,
                                        cursor: "pointer",
                                        marginTop: theme.MARGIN_SMALL,
                                        marginLeft: 35
                                    }}
                                >
                                    <pr.IconDownload style={{ marginRight: 5 }} />
                                    <span>{document.title}</span>
                                </div>
                            );
                        })}
                        {!externalInterfaceStore.isGeorgeApp &&
                            <pr.LightSeparatorLine spacing={theme.MARGIN} />
                        }
                        <george.ActionButton
                            messageId={store.isLoading ? undefined : "button.continue"}
                            disableButton={buttonDisabled}
                            isLoading={store.isLoading}
                            onClick={async () => {
                                debug.log("### email", store.contactsStore.selectedEmailAddressId);
                                debug.log("### address", store.contactsStore.selectedAddressId);
                                await trackingStore.trackEvent({ eventName: "nextPage" });
                                pushRoute(CreditCardUpgradeRoutes.SUMMARY);
                            }}
                            {...george.getActionButtonWebVersionProps()}
                        />
                    </pr.A11yPopupHider>
                </george.Card>
            </PageComponent>
        </george.BackgroundWithNavBar>

    );
});


// WEBPACK FOOTER //
// ./src/components/creditCardUpgrade/CreditCardUpgradePersonalData.tsx